export default {
  data() {
    return {
      heartbeatInterval: null,
    };
  },
  methods: {
    initSocket() {
      // Socket链接
      if (!!window.WebSocket && window.WebSocket.prototype.send) {
        if (typeof WebSocket !== "function" || typeof WebSocket === "undefined") {
          this.$socket = new SockJS(location.socketURL + 'sockjs');
        } else {
          this.$socket = new WebSocket(location.socketURL + 'websocket');
        }

        // 打开连接
        this.$socket.onopen = (event) => {
          this.heartbeatInterval = setInterval(() => {
            if (this.$socket.readyState === WebSocket.OPEN) {
              this.$socket.send("ping");
            }
          }, 50000); // 50秒一次
        };

        // 关闭连接
        this.$socket.onclose = (event) => {
          clearInterval(this.heartbeatInterval);

          // 自动重连
          setTimeout(() => {
            this.initSocket();
          }, 3000);
        };

        // 错误处理
        this.$socket.onerror = (event) => {
          // 可选：console.log("socket error:", event);
        };

        // 消息处理
        this.$socket.onmessage = (event) => {
          if (event.data === "INTERNAL_AGREEMENT") {
            this.$store.dispatch("INTERNAL_PENDING_COUNT");
          }
          if (event.data === "MARKETPLACE_AGREEMENT") {
            this.$store.dispatch("MARKETPLACE_PENDING_COUNT");
          }
          if (event.data === "CONTACT_BULK_UNLOCK") {
            this.$store.commit("CONTACT_BULK_UNLOCK");
          }
        };
      }
    },
    closeSocket() {
      if (this.$socket) {
        clearInterval(this.heartbeatInterval);
        this.$socket.close();
      }
    },
  },
  beforeDestroy() {
    if (this.$socket) {
      this.$socket.close();
    }
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
    }
  },
};


// WEBPACK FOOTER //
// ./src/mixins/socketMixin.js